import { useEffect } from 'react'

export function useBeforeunload(callback: (event: BeforeUnloadEvent) => unknown, options?: { capture?: boolean }) {
  const { capture } = options || {}

  useEffect(() => {
    const opts = capture != null ? { capture } : undefined
    window.addEventListener('beforeunload', callback, opts)
    return () => {
      window.removeEventListener('beforeunload', callback, opts)
    }
  }, [callback, capture])
}
